import ConfigurationWizard from '@/views/ConfigurationWizard.vue';
import ConfigurationWizardFirstThingsFirst from '@/components/configuration-wizard/ConfigurationWizardFirstThingsFirst.vue';
import ConfigurationWizardCreateEvent from '@/components/configuration-wizard/ConfigurationWizardCreateEvent.vue';
import ConfigurationWizardLetsGo from '@/components/configuration-wizard/ConfigurationWizardLetsGo.vue';

export default [
  {
    path: 'configuration-wizard',
    name: 'configuration.wizard',
    component: ConfigurationWizard,
    meta: {
      onlyBeforeFinishedWizard: true,
    },
    children: [
      {
        path: '',
        alias: 'first-things-first',
        name: 'configuration.wizard.first.things.first',
        component: ConfigurationWizardFirstThingsFirst,
      },
      {
        path: 'create-event',
        name: 'configuration.wizard.create.event',
        component: ConfigurationWizardCreateEvent,
      },
      {
        path: 'lets-go',
        name: 'configuration.wizard.lets.go',
        component: ConfigurationWizardLetsGo,
      },
    ],
  },
];
